import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Palette, Upload, PenTool } from "lucide-react";
import { Button } from "@/components/ui/button";
import DesignStudio from "@/components/DesignStudio";
import MyDesignUpload from "@/components/MyDesignUpload";

export const MyDesign = () => {
  const [mode, setMode] = useState(null); // 'create' or 'upload'

  const handleExport = (svgString, blob) => {
    console.log('Design exported, ready for submission');
    // The SVG can be sent to backend for quote/production
  };

  return (
    <div className="pt-24 pb-16 min-h-screen bg-gray-50" data-testid="my-design-page">
      <div className={`mx-auto px-4 md:px-8 ${mode === 'create' ? 'max-w-7xl' : 'max-w-2xl'}`}>
        {/* Back Link */}
        {/* Mode Selection */}
        {!mode && (
          <div className="text-center">
            <h1 className="text-3xl font-bold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              Create Your Own Graphics
            </h1>
            <p className="text-muted-foreground mb-8 max-w-lg mx-auto">
              Design your custom Mini graphics using our design studio, or upload your existing artwork for a quote.
            </p>
            
            <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
              {/* Design Studio Option */}
              <button
                onClick={() => setMode('create')}
                className="group p-8 bg-white rounded-2xl border-2 border-gray-200 hover:border-black transition-all text-left"
                data-testid="create-design-btn"
              >
                <div className="w-16 h-16 bg-black rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <PenTool className="h-8 w-8 text-white" />
                </div>
                <h2 className="text-xl font-bold mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Design Studio
                </h2>
                <p className="text-sm text-muted-foreground">
                  Create your graphics from scratch using our easy-to-use design tools. Add shapes, text, and images.
                </p>
                <p className="text-xs text-primary mt-3 font-medium">
                  Exports to SVG (vector format)
                </p>
              </button>

              {/* Upload Option */}
              <button
                onClick={() => setMode('upload')}
                className="group p-8 bg-white rounded-2xl border-2 border-gray-200 hover:border-black transition-all text-left"
                data-testid="upload-design-btn"
              >
                <div className="w-16 h-16 bg-black rounded-2xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <Upload className="h-8 w-8 text-white" />
                </div>
                <h2 className="text-xl font-bold mb-2" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Upload Your Design
                </h2>
                <p className="text-sm text-muted-foreground">
                  Already have artwork? Upload your AI, EPS, PDF, SVG, or image files for a custom quote.
                </p>
                <p className="text-xs text-primary mt-3 font-medium">
                  Supports AI, EPS, PDF, SVG, JPEG, PNG
                </p>
              </button>
            </div>
          </div>
        )}

        {/* Design Studio Mode */}
        {mode === 'create' && (
          <div>
            <div className="flex items-center justify-between mb-6">
              <div>
                <h1 className="text-2xl font-bold" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Design Studio
                </h1>
                <p className="text-sm text-muted-foreground">
                  Create your custom graphics - export as SVG when ready
                </p>
              </div>
              <Button variant="outline" onClick={() => setMode(null)} className="rounded-full">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Options
              </Button>
            </div>
            
            <DesignStudio onExport={handleExport} />
            
            <div className="mt-6 p-4 bg-blue-50 rounded-xl text-sm text-blue-800">
              <strong>Tip:</strong> Once you've created your design, export it as SVG and use the "Upload Your Design" option to submit it for a quote. SVG is a vector format that ensures your graphics are printed at the highest quality.
            </div>
          </div>
        )}

        {/* Upload Mode */}
        {mode === 'upload' && (
          <div>
            <div className="flex items-center justify-between mb-6">
              <div>
                <h1 className="text-2xl font-bold" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Upload Your Design
                </h1>
                <p className="text-sm text-muted-foreground">
                  Submit your artwork for a custom quote
                </p>
              </div>
              <Button variant="outline" onClick={() => setMode(null)} className="rounded-full">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Options
              </Button>
            </div>
            
            <MyDesignUpload />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyDesign;
